module.exports = __webpack_public_path__ + "img/ivana.893e041b.jpg";